import styled from '@emotion/styled';
import Info from '@engineering/icons/info';
import { Ui } from '@silvertours/front-shared';
import { ProviderDropdown } from '../ProviderDropdown';

export const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  font-family: ${({ theme }) => theme.fontFamily.default};
  margin-top: 1.5rem;
`;

export const DropdownWrapper = styled(InputWrapper)`
  display: flex;
  align-items: center;
  column-gap: 1rem;
`;

export const StyledProviderDropdown = styled(ProviderDropdown)`
  margin-top: 1.5rem;
`;

export const InputButtonLabel = styled.div`
  position: absolute;
  top: -0.5625rem;
  left: 0.75rem;
  padding: 0 ${({ theme }) => theme.spacing[10]};
  z-index: 2;
  color: ${({ theme }) => theme.colors.neutral.grey140};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  font-size: 0.75rem;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const InputButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem;
  border: 1px solid ${({ theme }) => theme.colors.neutral.grey100};
  border-radius: ${({ theme }) => theme.radius.sm};
  width: 100%;
  font-family: inherit;
  font-size: 1rem;
  line-height: 3.375;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.neutral.grey140};
  }

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

export const StyledDropdown = styled(Ui.Dropdown)`
  min-width: 8em;
  height: 3.375rem;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  fill: currentcolor;
`;

export const InfoIcon = styled(Info)`
  fill: ${({ theme }) => theme.colors.brand.green120};
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: middle;
  cursor: pointer;
`;
